<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2
              class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate"
            >
              Affiliate Users
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"></div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav
      class="bg-white border-b border-t border-gray-200 flex"
      aria-label="Breadcrumb"
    >
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a
              href="javascript:void(0)"
              class="text-gray-400 hover:text-gray-500"
            >
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg
              class="flex-shrink-0 w-6 h-full text-gray-200"
              viewBox="0 0 24 44"
              preserveAspectRatio="none"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link
              :to="page.href"
              class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined"
              >{{ page.name }}</router-link
            >
          </div>
        </li>
      </ol>
    </nav>

    <div class="">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center overflow-x-auto"
      >
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 px-2 flex justify-center lg:ml-6 lg:justify-start">
            <div class="max-w-lg w-64 lg:max-w-xs">
              <label for="search" class="sr-only">Search</label>
              <div
                class="flex row w-full relative text-gray-600 focus-within:text-gray-600"
              >
                <div
                  class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center"
                >
                  Date:
                </div>
                <div>
                  <input
                    id="from"
                    v-model="from"
                    maxlength="10"
                    class="block w-full bg-white py-2 pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-md"
                    placeholder="From"
                    type="date"
                    name="from"
                  />
                </div>
                <div
                  class="pointer-events-none inset-y-0 pl-1 left-0 flex items-center"
                >
                  to:
                </div>
                <div>
                  <input
                    id="to"
                    v-model="to"
                    maxlength="10"
                    class="block w-full bg-white py-2 pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-md"
                    placeholder="to"
                    type="date"
                    name="to"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8">
            <!-- <button type="button" class="ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500">
              <font-awesome-icon class="text-white mr-2" :icon="['far', 'filter']" transform=""/>
              Advance Filter
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="px-8 py-6" v-show="!isLoaded">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center"
      >
        <font-awesome-icon
          class="text-gray-500"
          :icon="['fas', 'circle-notch']"
          transform="grow-6"
          spin
        />
      </div>
    </div>

    <div class="py-6" v-show="isLoaded">
      <div class="sm:px-6 md:px-8">
        <div class="bg-white shadow sm:rounded-md">
          <div
            class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg"
          >
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Username
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Account
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
                  >
                    Topup
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
                  >
                    Register Date
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr
                  @click="viewData(data)"
                  @contextmenu="(e) => onAuxClick(e, data)"
                  v-for="data in dataRows"
                  :key="data.user_id"
                  class="hover:bg-gray-50 cursor-pointer"
                >
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ data["affilaite_data.username"] || data["affiliate.username"] }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ data["affilaite_data.account_name"] || data["affiliate.account_name"]  }}
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right"
                    :style="{
                      color:
                        +data.topup_total + +data.deposit_payment_total > 0
                          ? 'green'
                          : 'red',
                    }"
                  >
                    {{
                      parseFloat(
                        (+data.topup_total + +data.deposit_payment_total) / 100
                      ).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right"
                  >
                    {{
                      dayjs(data["affilaite_data.created_at"])
                        .locale("th")
                        .format("LLL")
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination v-model:config="pageConfig" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
} from "@heroicons/vue/solid";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import "dayjs/locale/th";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import { watchEffect } from "vue";
import stringify from "qs-stringify";
import Pagination from "@/components/tools/Pagination.vue";
import { watch } from "vue";

dayjs.extend(localizedFormat);

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    Pagination,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const searchInput = ref("");
    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);
    const pageConfig = ref({
      page: 1,
      count: 0,
      pageCount: 0,
      rowsPerPage: 10,
      search: "",
      isEmitOnClick: true,
      sort: [["created_at", "DESC"]],
    });
    let from = ref(
      dayjs(route.query.from).format("YYYY-MM-DD") ||
        new Date().toISOString().split("T")[0]
    );
    let to = ref(
      dayjs(route.query.to).format("YYYY-MM-DD") ||
        new Date().toISOString().split("T")[0]
    );

    onMounted(() => {
      refetch();
    });

    const pages = [
      { name: "Affiliate", href: "", current: false },
      { name: route.params.id, href: "", current: true },
    ];

    const refetch = () => {
      const { page, rowsPerPage } = pageConfig.value;
      const offset = (page - 1) * rowsPerPage;
      const limit = rowsPerPage;

      axios
        .get(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/customers/affiliate/${store.state.selectedOperator.operatorId}/list${route.query.type ? '-' + route.query.type : ''}/${route.query.from}/${route.query.to}`,
          {
            params: {
              aff_id: route.params.id,
              offset: offset,
              limit: limit,
            },
          }
        )
        .then(({ data }) => {
          if (!data || data.length == 0) {
            if (page == 1) {
              dataRows.value = [];
              isLoaded.value = true;
              return;
            }
            pageConfig.value.page = page - 1;
            return;
          }

          dataRows.value = data;
          // dataCount.value = data.count
          isLoaded.value = true;
        })
        .catch(({ response }) => {});
    };

    const getLocaleDate = (date) => {
      return dayjs(date).locale("th").format("LLL");
    };

    watchEffect(() => {
      window.history.replaceState(
        {},
        document.title,
        `?${stringify({
          from: from.value,
          to: to.value,
        })}`
      );
      route.query.from = from.value;
      route.query.to = to.value;
      refetch();
    });

    const prev = () => {
      if (route.query.page && route.query.page !== "1") {
        router
          .push({
            query: {
              page: parseInt(route.query.page) - 1,
            },
          })
          .then(() => {
            refetch();
          });
      }
    };

    const next = () => {
      router
        .push({
          query: {
            page: parseInt(route.query.page) + 1 || 2,
          },
        })
        .then(() => {
          refetch();
        });
    };

    const jump = (page) => {
      router
        .push({
          query: {
            page: page,
            size: 10,
          },
        })
        .then(() => {
          refetch();
        });
    };

    const onAuxClick = (e, data) => {
      e.preventDefault();
      window.open(`/players/${data.user_id}`);
      return false;
    };

    const viewData = (data) => {
      router.push({ name: "Wallet Info", params: { id: data.user_id } });
    };

    watch(
      () => pageConfig.value.page,
      () => refetch()
    );
    /** fetch data when rows per page was changed */
    watch(
      () => pageConfig.value.rowsPerPage,
      () => {
        pageConfig.value.page = 1;
        refetch();
      }
    );

    return {
      dataRows,
      dataCount,
      isLoaded,
      dayjs,
      searchInput,
      route,
      store,
      prev,
      next,
      jump,
      // search,
      pages,
      getLocaleDate,
      viewData,
      from,
      to,
      pageConfig,
      onAuxClick,
    };
  },
};
</script>
